import { Component, AfterViewInit } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/interaction';
import interactionPlugin from '@fullcalendar/interaction';
import { PopupDialogComponent } from '../popup-dialog/popup-dialog.component'
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../shared/utils/const';
import { DatePipe } from '@angular/common';
import { MSMEEventListModel } from '../../../shared/models/MSMEEventListModel';

@Component({
  selector: 'app-full-calender',
  templateUrl: './full-calender.component.html',
  styleUrls: ['./full-calender.component.css']
})
export class FullCalenderComponent implements AfterViewInit {
  userId: any;
  msMeUserName = sessionStorage.getItem('msMeUserName');
  userType = sessionStorage.getItem('UserType');
  eventData: any = [];  // Stores fetched event data

  // FullCalendar Options
  calendarOptions: CalendarOptions = {
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    initialView: 'dayGridMonth',
    weekends: true,
    events: [], // Empty initially, to be populated once data is loaded
    eventClick: this.onEventClick.bind(this)  // Bind event click handler
  };

  constructor(private dialog: MatDialog, private apiService: ApiService) {
    this.userId = sessionStorage.getItem('iauserid');
  }

  ngAfterViewInit() {
    // Load event data once the component is initialized
    if (this.userType === 'MSME') {
      this.LoadMSMEEventDetails();
    } else {
      this.loadEventData();
    }
  }

  // Fetch Event Data for IA user
  loadEventData() {
    this.apiService.getRequest(API_ENDPOINTS.IA.GETIAEVENTDATE, { userId: this.userId }).subscribe(
      result => {
        if (result.status) {
          sessionStorage.setItem('eventData', JSON.stringify(result.data));
          this.eventData = result.data;
          this.updateCalendarEvents();
        }
      }
    );
  }

  // Fetch Event Data for MSME user
  LoadMSMEEventDetails() {
    var dtoUdyamNumber = { UdyamRegistrationNumber: this.msMeUserName };
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETMSMEEVENTDATES, dtoUdyamNumber)
      .subscribe((result: MSMEEventListModel) => {
        if (result.status) {
          sessionStorage.setItem('eventData', JSON.stringify(result.data));
          this.eventData = result.data;
          this.updateCalendarEvents();
        }
      });
  }

  // Convert Date to desired format
  convertDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // Update FullCalendar events after data is fetched
  updateCalendarEvents() {
    // After data is fetched, update the 'events' array in calendar options
    this.calendarOptions.events = this.eventData;

    // If the calendar is already initialized, refresh the events
    //if (window['calendarApi']) {
    //  window['calendarApi'].refetchEvents();
    //}
  }

  // Handle event click on the calendar
  onEventClick(info:any) {
    const datePipe = new DatePipe('en-US');
    const date = datePipe.transform(info.event.start, 'yyyy-MM-dd');

    if (this.userType === 'MSME') {
      const dtoGetMSMEEventDateWiseForCalendar = {
        UdyamRegistrationNumber: this.msMeUserName,
        EventDate: date
      };

      this.apiService.getRequest(API_ENDPOINTS.MSME.GETMSMEEVENTDATEWISEFORCALENDAR, dtoGetMSMEEventDateWiseForCalendar)
        .subscribe(result => {
          if (result.status) {
            const eventData = result.data;
            const dialogRef = this.dialog.open(PopupDialogComponent, { data: eventData });
            dialogRef.afterClosed().subscribe(() => { });
          }
        });
    } else {
      this.apiService.getRequest(API_ENDPOINTS.IA.GETIAEVENTCALENDERDATELIST, { eventDate: date, userId: this.userId })
        .subscribe(result => {
          if (result.status) {
            const eventData = result.data;
            const dialogRef = this.dialog.open(PopupDialogComponent, { data: eventData });
            dialogRef.afterClosed().subscribe(() => { });
          }
        });
    }
  }
}
